/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestions_Prompt_4Inputs */

const es_chat_suggestions_prompt_4 = /** @type {(inputs: Chat_Suggestions_Prompt_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar documentos actualizados este mes`)
};

const en_chat_suggestions_prompt_4 = /** @type {(inputs: Chat_Suggestions_Prompt_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find documents updated this month`)
};

/**
* | output |
* | --- |
* | "Find documents updated this month" |
*
* @param {Chat_Suggestions_Prompt_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_prompt_4 = /** @type {((inputs?: Chat_Suggestions_Prompt_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Prompt_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_prompt_4(inputs)
	return en_chat_suggestions_prompt_4(inputs)
});
export { chat_suggestions_prompt_4 as "chat.suggestions.prompt_4" }